import { InlineResponse200, Log } from "../interface";
import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function getLogs(pg: number, filter?: string): Promise<InlineResponse200<Log> | null> {
    if (api.clientApi) {
        return api.clientApi.clientAuditlogList(store.db ? store.db : "", pg, filter ? filter : "").then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
                return null;
            }
            return response as unknown as InlineResponse200<Log>;
        });
    } else {
        return null;
    }
}

export { getLogs };
